import { render, staticRenderFns } from "./DiscountLicense.vue?vue&type=template&id=039ab17f&lang=pug"
import script from "./DiscountLicense.vue?vue&type=script&lang=js"
export * from "./DiscountLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports